// Iter XX.56 — LandingV2 analytics wrapper. Reuses the existing
// checkoutBeacon.js `/plus/track` beacon so nothing new is created.
import api from "./api";

let _variant = "control";
export function setLandingVariant(v) { _variant = v || "control"; }

function _fire(kind, payload = {}) {
  try {
    api.post("/plus/track", {
      kind,
      payload: { ...payload, variant: _variant, ts: Date.now() },
    }).catch(() => {});
  } catch { /* analytics must never break the page */ }
}

// Public API — one call per event kind, matching the plan doc.
export const track = {
  viewed:              (p) => _fire("landing_v2_viewed", p),
  primaryCta:          (p) => _fire("landing_v2_primary_cta_click", p),
  secondaryCta:        (p) => _fire("landing_v2_secondary_cta_click", p),
  actionTile:          (tile, p) => _fire("landing_v2_action_tile_click", { tile, ...p }),
  journeyCardViewed:   (p) => _fire("landing_v2_journey_card_viewed", p),
  continueLast:        (p) => _fire("landing_v2_continue_last", p),
  firstMessage:        (p) => _fire("landing_v2_first_message_after_home", p),
  meaningfulReached:   (p) => _fire("landing_v2_meaningful_conversation_reached", p),
  secondSession:       (p) => _fire("landing_v2_second_session_reached", p),
  sevenDayReturn:      (p) => _fire("landing_v2_seven_day_return", p),
  videoAction:         (p) => _fire("landing_v2_video_action_selected", p),
};
